module.exports = __webpack_public_path__ + "img/5.156370e5.jpg";